const STREAM_FILTERS_STORAGE_KEY = 'streamFilters';

export const DEFAULT_STREAM_FILTERS = {
  gender: 'all',
  sort: 'new',
};

const VALID_GENDERS = new Set(['all', 'male', 'female']);
const VALID_SORTS = new Set(['new', 'popular']);

export const normalizeStreamFilters = (filters = {}) => ({
  gender: VALID_GENDERS.has(filters?.gender) ? filters.gender : DEFAULT_STREAM_FILTERS.gender,
  sort: VALID_SORTS.has(filters?.sort) ? filters.sort : DEFAULT_STREAM_FILTERS.sort,
});

export const saveStreamFiltersToLocalStorage = (filters) => {
  try {
    const normalizedFilters = normalizeStreamFilters(filters);
    localStorage.setItem(STREAM_FILTERS_STORAGE_KEY, JSON.stringify(normalizedFilters));
    return normalizedFilters;
  } catch (error) {
    console.error('Error saving stream filters to localStorage:', error);
    return normalizeStreamFilters(filters);
  }
};

export const loadStreamFiltersFromLocalStorage = () => {
  try {
    const savedFilters = localStorage.getItem(STREAM_FILTERS_STORAGE_KEY);
    if (!savedFilters) {
      return null;
    }

    return normalizeStreamFilters(JSON.parse(savedFilters));
  } catch (error) {
    console.error('Error loading stream filters from localStorage:', error);
    return null;
  }
};

export const resolveStreamFilters = (searchParams) => {
  const hasSearchFilters = searchParams?.has('gender') || searchParams?.has('sort');

  if (hasSearchFilters) {
    return normalizeStreamFilters({
      gender: searchParams.get('gender'),
      sort: searchParams.get('sort'),
    });
  }

  return loadStreamFiltersFromLocalStorage() || DEFAULT_STREAM_FILTERS;
};

export const buildStreamSearchParams = (filters) => {
  const normalizedFilters = normalizeStreamFilters(filters);
  const params = new URLSearchParams();

  if (normalizedFilters.gender !== DEFAULT_STREAM_FILTERS.gender) {
    params.set('gender', normalizedFilters.gender);
  }

  if (normalizedFilters.sort !== DEFAULT_STREAM_FILTERS.sort) {
    params.set('sort', normalizedFilters.sort);
  }

  return params;
};
